var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-btn",
    { attrs: { outline: "" }, on: { click: _vm.handleContactSupport } },
    [_vm._v(_vm._s(_vm.$t("contact_support")))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }